export default __webpack_public_path__ + "static/media/gallery-12-4.80767be0.webp";